import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompose';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';

import immutableToJS from 'helpers/immutableToJS';
import { getOrganizationUID } from 'helpers/utils';
import {
  injectIntl,
  Paper,
  UnauthorizedHeader,
} from 'components';
import { withTracker } from 'components/Tracker';
import { getMarketPlaceDetails } from 'redux/marketPlace/actions';
import { selectState } from 'redux/selectors';


const styles = () => ({
  productImage: { width: '100%' },
});

class MarketPlaceDetails extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape().isRequired,
  }

  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string,
      }),
    }).isRequired,
    storeItemDetails: PropTypes.shape({}).isRequired,
    storeItemDetailsRequesting: PropTypes.bool,

    formatMessage: PropTypes.func.isRequired,
    getStoreItemDetails: PropTypes.func.isRequired,
  };

  static defaultProps = {
    storeItemDetailsRequesting: false,
  };

  componentDidMount() {
    const {
      getStoreItemDetails,
      match: {
        params: {
          id,
        },
      },
    } = this.props;
    getStoreItemDetails(id);
  }

  render() {
    const { currentUser } = this.context;
    const {
      classes,
      formatMessage,
      history,
      storeItemDetails,
      storeItemDetailsRequesting,
    } = this.props;

    if (storeItemDetailsRequesting) {
      return (
        <Fragment>
          <UnauthorizedHeader headerTitle={formatMessage('Loading ...')} />
          <Paper className="d-flex justify-content-center align-items-center">
            <CircularProgress />
          </Paper>
        </Fragment>
      );
    } else if (!storeItemDetails.id) {
      return (
        <Fragment>
          <UnauthorizedHeader headerTitle={formatMessage('Not Found')} />
          <Paper className="d-flex justify-content-center align-items-center">
            <h2>{formatMessage('Product Not Found')}</h2>
          </Paper>
        </Fragment>
      );
    }

    const {
      image,
      productData,
      user: {
        account: {
          profile: farmProfile,
        },
      },
    } = storeItemDetails;

    return (
      <Fragment>
        <UnauthorizedHeader headerTitle={`${productData.name} - ${productData.subname}`} />
        <Paper>
          <div className="align-center">
            <div style={{ maxWidth: '100%', width: 300, margin: 'auto' }}>
              <img className={classes.productImage} src={image} alt="" style={{ maxWidth: 300, margin: 'auto' }} />
            </div>
            <div style={{ maxWidth: '100%', width: 500, margin: '30px auto' }}>
              <h2>{formatMessage('Name')}: {productData.name}</h2>
              <h3>{formatMessage('Subname')}: {productData.subname}</h3>
              <h3>{formatMessage('Category')}: {productData.category}</h3>
              <h3>{formatMessage('Farm')}:&nbsp;
                <Link to={`/+${getOrganizationUID(farmProfile.companyName)}`}>
                  {farmProfile.companyName}
                </Link>
              </h3>
              <h3>{formatMessage('Bio')}: {farmProfile.bio}</h3>
              {!currentUser.id &&
                <Fragment>
                  <h3>{formatMessage('If you want to contact the farm, please sign up.')}</h3>
                  <Button
                    className="button"
                    color="primary"
                    onClick={() => history.push('/')}
                    variant="contained"
                  >
                    {formatMessage('Sign Up')}
                  </Button>
                </Fragment>
              }
            </div>
          </div>
        </Paper>
      </Fragment>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('marketPlace', 'marketPlaceDetails')(state, 'storeItemDetails'),
});

export default compose(
  setDisplayName('MarketPlaceDetails'),
  connect(
    mapStateToProps,
    dispatch => ({
      getStoreItemDetails: id => dispatch(getMarketPlaceDetails(id)),
    }),
  ),
  withStyles(styles),
  immutableToJS,
  injectIntl,
  withTracker,
)(MarketPlaceDetails);
